var mieszkaniaTableInit;

(function ($) {

	const selectors = {
		box: '[data-mieszkania-table]',
		fixed: '[data-mieszkania-table-fixed]',
		table: '[data-mieszkania-table-regular]'
	}


	mieszkaniaTableInit = function () {
		$(selectors.box).each((i, el) => {
			new MieszkaniaTable(el);
		});
	}

	class MieszkaniaTable {
		constructor(element) {
			this.$box = $(element);

			if (this.$box.length) {
				this.init();
			}

		}
		init() {

			this.$table = $(selectors.table, this.$box);
			this.$header = $(selectors.fixed, this.$box);

			this.bind();
			this.scroll();
			this.resize();
			this.copyHeading();
		}

		bind() {

			const self = this;

			this.resize = this.resize.bind(this);
			this.scroll = this.scroll.bind(this);
			this.copyHeading = this.copyHeading.bind(this);
			this.onFixedHeadingCellClicked = this.onFixedHeadingCellClicked.bind(this);

			$(window).on('resize', this.resize);
			$(window).on('scroll', this.scroll);

			$('tbody td', this.$table).click(this.onTableRowClicked);
			$('tbody td a', this.$table).click((e) => { e.stopPropagation() });

			$('thead td', this.$header).click(function () { self.onFixedHeadingCellClicked(this); });
			$('thead td', this.$table).click(this.copyHeading);
		}

		resize() {

			const self = this;

			self.$header.css('width', self.$table.outerWidth());
			self.$table.find('thead td').each((i, el) => {
				self.$header.find('thead td').eq(i).css('width', $(el).outerWidth());
			});

		}

		scroll() {

			const scroll = $(window).scrollTop() + $('.c-top-bar').outerHeight();
			const minScroll = this.$table.offset().top;
			const maxScroll = this.$table.offset().top + this.$table.outerHeight() - this.$header.outerHeight();


			if (scroll > minScroll && scroll < maxScroll) {
				this.$header.addClass('is-fixed');
			}
			else {
				this.$header.removeClass('is-fixed');
			}

		}

		onTableRowClicked() {
			var btn = $(this).closest('tr').find('.c-mieszkania-table__cell--btn a');
			if (btn.length) {
				window.location.href = btn.attr('href');
			}
		}

		copyHeading() {
			const self = this;
			$('thead td', self.$table).each((i, el) => {
				const idx = $(el).index();
				$('thead td', self.$heading).eq(idx).attr('class', $(el).attr('class'));
				$('thead td', self.$heading).eq(idx).html($(el).html());
			});
		}

		onFixedHeadingCellClicked(el) {
			const idx = $(el).index();
			$('thead td', this.$table).eq(idx).trigger('click');
		}

	}

})(jQuery);


export default mieszkaniaTableInit;